import * as _ from "lodash";

import BankAccountSelectElement from "./BankAccountSelectElement";
import { Link } from "react-router-dom";
import React from "react";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";

const BankAccountSelect = ({
  onSelected,
  value,
  displayClosed,
  hidePencil,
  bankAccounts,
  companyId,
  intl
}) => {
  // console.log("bankAccounts", bankAccounts);
  let bankAccountElements = bankAccounts.map(account => {
    return {
      label: <BankAccountSelectElement companyId={companyId} bankAccount={account} intl={intl} />,
      value: account.id,
      account
    };
  });

  if (displayClosed === undefined) displayClosed = true;

  if (!displayClosed) {
    let linesToRemove = [];

    // Check Company Id. If not null, not generic category
    _.forEach(bankAccountElements, bank => {
      if (
        bank.account.dateCloture !== null &&
        bank.account.dateCloture !== undefined
      ) {
        linesToRemove.push(bank);
      }
    });

    if (linesToRemove.length > 0) {
      _.forEach(linesToRemove, bank => {
        let index = bankAccountElements.indexOf(bank);
        bankAccountElements.splice(index, 1);
      });
    }
  }

  if (bankAccountElements.length === 1) {    
    if (value === undefined) {
      value = bankAccountElements[0].value; 
    }
  }

  return (
    <div className="space-between full-width">
      <SimpleSelect
        name="bankAccounts"
        value={value}
        onSelected={onSelected}
        options={bankAccountElements}
        clearable={false}
        // creatable
      />
      {value && hidePencil !== true ? (
        <Link
          style={{ fontSize: "19px", marginLeft: "5px", marginTop: "5px" }}
          to={`/payments/bank_accounts/${value}/edit`}>
          <i className="fa fa-pencil" />
        </Link>
      ) : (
        <div />
      )}
    </div>
  );
};

export default BankAccountSelect;
